//40
export const space1WallData = [
        {
            position : [0, 5,117],
            size : [360,10,10.5],
        },
        {
            position : [0, 5, -118.5],
            size : [360,10,10.5],
        },
        {
            position : [165, 5, 0],
            size : [10.5,10,270],
        },
        {
            position : [-165, 5, 0],
            size : [10.5,10,270],
        },
        {
            position : [52.5, 5, -33],
            size : [18 ,10, 45],
        },
        {
            position : [33, 5, -13.5],
            size : [12,10,5],
        },
        {
            position : [-48, 5, -33],
            size : [12,10,47],
        },
        {
            position : [-33, 5, -13.5],
            size : [18, 10, 7.5],
        },
        {
            position : [-51, 5, -93],
            size : [12,10,45],
        },
        {
            position : [-39, 5, 7.5],
            size : [30,10,4.5],
        },
        {
            position : [39, 5, 7.5],
            size : [30,10,4.5],
        },
        {
            position : [57, 5, -93],
            size : [12,10,45],
        },
        {
            position : [57, 5, 27],
            size : [12,10,45],
        },
        {
            position : [-51, 5, 28.5],
            size : [7.5,10,45],
        },
        {
            position : [-51, 5, 91.5],
            size : [12,10,45],
        },
        {
            position : [57, 5, 87],
            size : [18,10,45],
        },
        {
            position : [3, 5, -36],
            size : [12,10,34.5],
        },

        {
            position : [-48, 5, -72],
            size : [30,10,4.5],
        },

        {
            position : [48, 5, -69],
            size : [30,10,4.5],
        },
        {
            position : [48, 5, -57],
            size : [30,10,3],
        },
        {
            position : [-40.5, 5, -58.5],
            size : [33,10,3],
        },

        {
            position : [4.5, 5, -78],
            size : [13.5,10,12],
        },
        {
            position : [0, 5, 75],
            size : [13.5 ,10, 12],
        },
        {
            position : [0, 5, 37.5],
            size : [21,10,30],
        },
        {
            position : [1.5, 5, -106.5],
            size : [33, 10, 10.5],
        },
        {
            position : [-142.5, 5, -99],
            size : [37,5,10,7.5],
        },
        {
            position : [-138, 5, -81],
            size : [48, 10, 10.5],
        },
        {
            position : [-138, 5, -81],
            size : [48, 10, 10.5],
        },
        {
            position : [-111, 5, -82.5],
            size : [1.5,10,22.5],
        },
        {
            position : [-135, 5, 28.5],
            size : [48, 10, 10.5],
        },
        {
            position : [-108, 5, 30],
            size : [1.5, 10, 22.5],
        },
        {
            position : [-138, 5, 72],
            size : [42,10,10.5],
        },
        {
            position : [-117.75, 5, 67.5],
            size : [1.5,10,30],
        },
        {
            position : [-150, 5, 51],
            size : [36, 10, 7.5],
        },
        {
            position : [-132, 5, 51],
            size : [3 ,10, 13.5],
        },
        {
            position : [0, 5, 105.5],
            size : [35, 10, 10.5],
        },
        {
            position : [143, 5, 92],
            size : [34, 10, 8],
        },
        {
            position : [132, 5, 71],
            size : [60, 10, 10],
        },
        {
            position : [132, 5, -2],
            size : [70, 10, 10],
        },
        {
            position : [132, 5, -39.5],
            size : [78, 10, 10],
        },
        {
            position : [139, 5, -60],
            size : [40, 10, 10],
        },
        {
            position : [139, 5, -80],
            size : [44, 10, 10],
        },
        {
            position : [101, 5, 71],
            size : [1, 10, 35],
        },
        {
            position : [114, 5, 105],
            size : [1, 10, 15],
        },
        {
            position : [95, 5, 1],
            size : [1, 10, 15],
        },
        {
            position : [99, 5, -37],
            size : [1, 10, 35],
        },
        {
            position : [132, 5, -30],
            size : [1, 10, 20],
        },
        {
            position : [117, 5, -86],
            size : [1, 10, 20],
        },
        {
            position : [53, 5, 51],
            size : [40, 10, 3],
        },
        {
            position : [-46, 5, 55],
            size : [40, 10, 3],
        },
        
]

//micro

export const space2WallData = [
    {
        position : [0, 5, -49.5],
        size : [255,10,7.5],
    },
    {
        position : [0, 5, 48],
        size : [255,10,7.5],
    },
    {
        position : [114, 5, 0],
        size : [7.5,10,150],
    },
    {
        position : [-114, 5, 0],
        size : [7.5,10,150],
    },
    {
        position : [-105, 5, 11.25],
        size : [15 ,10,11.5],
    },
    {
        position : [-105, 5, -15.75],
        size : [15,10, 11.5],
    },
    {
        position : [-72, 5, 11.25],
        size : [24,10,11.25],
    },
    {
        position : [-72, 5, -15.75],
        size : [24,10,11.25],
    },
    {
        position : [-72.75, 5, 27],
        size : [1.5,10,33],
    },
    {
        position : [-72.75, 5, -30],
        size : [1.5,10,33],
    },
    {
        position : [-36, 5, 27],
        size : [1.5,10,40.5],
    },
    {
        position : [-36, 5, -30],
        size : [1.5,10,33],
    },
    {
        position : [-33, 5, 33],
        size : [6,10,22.5],
    },
    {
        position : [-42, 5, 11.25],
        size : [13.5, 10, 11.25],
    },
    {
        position : [-42, 5, -15.75],
        size : [13.5, 10, 11.25],
    },
    {
        position : [-30, 5, -12.75],
        size : [13.5,10,5.25],
    },
    {
        position : [105, 5, -13.5],
        size : [13.5,10,6],
    },
    {
        position : [15, 5, 39],
        size : [6, 10, 5],
    },
    {
        position : [15, 5, 25],
        size : [7, 10, 5],
    },
    {
        position : [63, 5, 43],
        size : [8, 10, 5],
    },
    {
        position : [63, 5, 28],
        size : [8, 10, 5],
    },
    {
        position : [108, 5, 34],
        size : [5, 10, 30],
    },
]


//rece
export const space3WallData = [
    {
        position : [0, 5, -36.5],
        size : [200,10,7.5],
    },
    {
        position : [0, 5, 34],
        size : [200,10,7.5],
    },
    {
        position : [93, 5, 0],
        size : [7.5,10, 150],
    },
    {
        position : [-92, 5, 0],
        size : [7.5,10, 150],
    },
    {
        position : [-67, 5, 7],
        size : [43,10, 13],
    },
    {
        position : [59, 5, 7],
        size : [58,10, 13],
    },
    {
        position : [-84, 5, -18],
        size : [13,10, 25],
    },
    {
        position : [-67, 5, -7],
        size : [23,10, 3],
    },
    {
        position : [-29, 5, -28],
        size : [18,10, 10],
    },

    //
    {
        position : [29, 5, -29],
        size : [18,10, 10],
    },
    {
        position : [29, 5, -12],
        size : [18,10, 10],
    },
    {
        position : [9, 5, -12],
        size : [22,10, 5],
    },

    {
        position : [-25.5, 5, -12.5],
        size : [23,10, 8],
    },
    {
        position : [85, 5, -18],
        size : [13,10, 25],
    },
    {
        position : [58, 5, -30],
        size : [60,10, 5],
    },
]

export const space4WallData = [
    {
        position : [9, 5, 0],
        size : [3,10,45]
    },
    {
        position : [24, 5, -18],
        size : [31.5,10,13.5]
    },
    {
        position : [21, 5, 21],
        size : [22.5,10,10.5]
    },
    {
        position : [135, 5, 7.5],
        size : [10.5,10,300]
    },
    {
        position : [7.5, 5, -123],
        size : [300,10,10.5]
    },
    {
        position : [-138, 5, 7.5],
        size : [10.5,10,300]
    },
    {
        position : [7.5, 5, 126],
        size : [300,10,10.5],
        // trigger : true
    },
    {
        position : [-40.5, 5, 22.5],
        size : [37.5,10,10.5],
        // trigger : true
    },
    {
        position : [-42, 5, -19.5],
        size : [42,10,10.5],
        // trigger : true
    },
    {
        position : [-21, 5, 0],
        size : [3,10,45]
    },
    {
        position : [-75, 5, 0],
        size : [3,10,45]
    },
    {
        position : [-91.5, 5, 0],
        size : [3,10,48]
    },
    {
        position : [52.5, 5, 3],
        size : [3,10, 55.5]
    },
    {
        position : [81, 5, 0],
        size : [3,10,51]
    },
    {
        position : [97.5, 5, 1.5],
        size : [3, 10, 57]
    },
    {
        position : [-118.5, 5, -18],
        size : [27,10,10.5]
    },
    {
        position : [117, 5, -18],
        size : [21, 10, 10.5]
    },
    {
        position : [118.5, 5, 21],
        size : [18,10,12]
    },
    {
        position : [-120, 5, 21],
        size : [21,10,12]
    },
    {
        position : [-72, 5, 21],
        size : [9,10,12]
    },
    {
        position : [60, 5, -19.5],
        size : [12,10,9]
    },
    {
        position : [72, 5,25.5],
        size : [21,10,9]
    },
]


export const space5WallData = [
    {
        position : [1, 5, -62],
        size : [200,10, 16],
    },
    {
        position : [1, 5, 65],
        size : [200,10, 16],
    },
    {
        position : [-94, 5, 2],
        size : [5,10, 150],
    },
    {
        position : [94, 5, 2],
        size : [5,10, 150],
    },
    {
        position : [-77, 5, -21],
        size : [28,10, 11],
    },
    {
        position : [-32.5, 5, -26],
        size : [37,10, 11],
    },
    {
        position : [31, 5, -23],
        size : [39,10, 11],
    },
    {
        position : [79, 5, -22],
        size : [25,10, 10],
    },
    {
        position : [-43, 5, -40],
        size : [6,10, 30],
    },
    {
        position : [46, 5, -40],
        size : [4,10, 30],
    },
    {
        position : [30, 5, 44],
        size : [14,10, 26],
    },
    {
        position : [-30, 5, 44],
        size : [16,10, 27],
    },
]